export default __webpack_public_path__ + "img/gfx_newsletter-79e749905b41dfcdaa71e65730b1a6cf.png";